module.exports = __webpack_public_path__ + "img/img-cardnews-02-3.2e00d772.png";